// ==============================|| OVERRIDES - DIALOG ||============================== //

// import { alpha } from "@mui/material/styles";

export default function Dialog(theme) {
	return {
		MuiDialog: {
			styleOverrides: {
				root: {
					margin: 'auto',
					'& .MuiBackdrop-root': {
						// backgroundColor: alpha('#F6F6F6', 0.7) Δεν βλέπω κάπου να υπάρχει στο Figma
					}
				},
				paper: {
					padding: '30px 1.875rem',
					borderRadius: '1.25rem',
					background: '#FCFCFC',
					boxShadow: 'none',
				}
			}
		}
	}
}

